import React, { Component } from "react"

/* Icons */
import { CaretDownOutlined } from '@ant-design/icons'

/* Constants */
import { env, utils } from "../constants"

/* Components */
import { Picture } from "@cuba-go/poker-ui"

/* Moment */
import moment from "moment"
import 'moment/locale/ru'
moment.locale('ru')


/* Component History */
class UVPHistory extends Component {

    constructor() {
        super()

        this.state = {
            active: -1
        }
    }


    makeArray = (value) => {

        if (!value) return []

        if (Array.isArray(value)) return value

        return String(value)
            .split(',')
            .filter(Boolean)
            .map(n => Number(n))
    }


    /* Determine and draw total */
    _total = data => {

        let total = 0
        let currency = "USD"

        if (data.transactions && Array.isArray(data.transactions) && data.transactions.length > 0) {

            data.transactions.forEach(transaction => {

                if (transaction.type === 'credit') {
                    total = total + parseFloat(transaction.total)
                }

                if (transaction.type === 'debit') {
                    total = total - parseFloat(transaction.total)
                }

                currency = transaction.currency

            })

        }

        if (total > 0) {
            return <div className="history-head-total">+ {utils.convertor(Math.abs(total), currency)}</div>
        }

        if (total < 0) {
            return <div className="history-head-total">- {utils.convertor(Math.abs(total), currency)}</div>
        }

        return <div className="history-head-total">{utils.convertor(total, currency)}</div>
    }


    /* Draw time */
    _time = data => {

        if (data.createdAt) {

            const date = moment(data.createdAt).format("YYYY-MM-DD")
            const today = moment(new Date()).format("YYYY-MM-DD")

            const yesterdayD = new Date()
            yesterdayD.setDate(yesterdayD.getDate() - 1)
            const yesterday = moment(yesterdayD).format("YYYY-MM-DD")

            let text = date

            if (moment(date).isSame(today, 'day')) {
                text = 'Сегодня'
            }
            else if (moment(date).isSame(yesterday, 'day')) {
                text = 'Вчера'
            }

            return (
                <div className="history-head-datetime">
                    <div className="history-head-time">{moment(data.createdAt).format("HH:mm")}</div>
                    <div className="history-head-date">{text}</div>
                </div>
            )
        }
    }


    /* Draw cards */
    _cards = data => {

        const boxes = this.makeArray(data.boxes)

        let dealer = []
        let player = []
        let additional = []

        /* Cards */
        if (Array.isArray(data.cards) && data.cards.length > 0) {
            data.cards.forEach(card => {
                if (card.type === "dealer") {
                    dealer.push(card)
                }
                if (card.type === "player") {
                    player.push(card)
                }
                if (card.type === "additional") {
                    additional.push(card)
                }
            })
        }

        const boxCards = (array, box) => {
            return array.filter(c => c && c.box && parseInt(c.box) === parseInt(box))
        }

        const gameResult = (type, box = 0) => {
            const i = data.results.findIndex(e => e && (e.player === type || parseInt(e.box) === parseInt(box)))
            if (i !== -1) {
                return data.results[i].result
            }

            return null
        }

        return (
            <div className="modal-boxes ultimate">
                <div className="game-result-cards">
                    <div className="rmp--modal-box-item">
                        {dealer.length > 0 ? <div className="modal-box-text"><p>Карты дилера</p></div> : null}
                        <div className="modal-cards">
                            {dealer.map((card, index) =>
                                <div key={`${index}`} className="modal-card-item">
                                    <Picture src={`${env.mediapoint}/cards/${card.image}`} alt="Card" />
                                </div>
                            )}
                        </div>
                        <div className="modal-box-result">{gameResult('dealer')}</div>
                    </div>
                </div>
                <div className="game-result-cards">
                    <div className="rmp--modal-box-item" style={{ margin: "10px 0px" }}>
                        {additional.length > 0 ? <div className="modal-box-text"><p>Дополнительные карты</p></div> : null}
                        <div className="modal-cards">
                            {additional.map((card, index) =>
                                <div key={`${index}`} className="modal-card-item" style={{ opacity: card.status === "hidden" ? 0.5 : 1 }}>
                                    <Picture src={`${env.mediapoint}/cards/${card.image}`} alt="Card" />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="game-result-cards">
                    {boxes.map(box => {

                        const cards = boxCards(player, box)

                        return (
                            <div className="rmp--modal-box-item" key={`box-cards-${box + 1}`}>
                                {cards.length > 0 ? <div className="modal-box-text"><p>Бокс - {box}</p></div> : null}
                                <div className="modal-cards">
                                    {cards.map((card, index) =>
                                        <div key={`${index}`} className="modal-card-item" style={{ opacity: card.status === "hidden" ? 0.5 : 1 }}>
                                            <Picture src={`${env.mediapoint}/cards/${card.image}`} alt="Card" />
                                        </div>
                                    )}
                                </div>
                                <div className="modal-box-result">{gameResult('player', box)}</div>
                            </div>
                        )
                    })}

                </div>
            </div>
        )

    }


    /* Draw current game */
    _currentGame = () => {

        /* Props and state */
        const { info, transactions } = this.props
        const { active } = this.state

        if (info && transactions && Array.isArray(transactions) && transactions.length > 0) {
            return (
                <div className="history-item">

                    {/* Draw history head */}
                    <div onClick={() => this.setState({ active: active === 'current' ? -1 : 'current' })} className={`history-head ${'current' === active ? 'history-active-head' : ''}`}>

                        <div className="history-number">
                            Игра #{info.number}
                            <div className="history-number-text"> (ТЕКУЩАЯ ИГРА)</div>
                        </div>

                        <div className="history-head-right">
                            <CaretDownOutlined />
                        </div>

                    </div>

                    <div className={`history-hidden-box ${'current' === active ? 'history-hidden-box-active' : ''}`}>

                        {(transactions && Array.isArray(transactions) && transactions.length > 0) &&
                            <div className="history-transactions">
                                <table className="operations-table">
                                    <thead>
                                        <tr>
                                            <th>Вид ставки</th>
                                            <th>Значение</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {transactions.map((transaction, index) =>
                                            <tr key={`h-o-${index}`} className="item">
                                                <td>{transaction.reason}</td>
                                                <td>{utils.convertor(transaction.total, transaction.currency)}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        }
                    </div>
                </div>
            )
        }

        return null
    }

    /* Operations list */
    operationsList = (item, index) => {

        const { currency } = this.props

        const boxes = this.makeArray(item.boxes)

        if (item.processes && Array.isArray(item.processes) && item.processes.length > 0) {

            let total = 0
            let totalWin = 0

            item.processes.forEach(item => {
                if (item.total && item.type !== 'maxpay') {
                    total += parseFloat(item.total)
                }
                if (item.win) {
                    totalWin += parseFloat(item.win)
                }
            })

            let gameProcesses = [[], [], []]

            boxes.forEach((box, index) => {
                const boxIndex = box - 1 >= 0 ? box - 1 : 0
                gameProcesses[boxIndex] = item.processes.filter((e) => parseInt(e.box) === parseInt(box))
            })

            const refundList = item.processes.filter(e => e.type === 'refund')

            return (
                <div className="history-transactions" key={`o-t-${index}`}>
                    <table className="operations-table">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Вид ставки</th>
                                <th>Cтавка</th>
                                <th>Выигрыш</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                gameProcesses.map((array, ind) => {

                                    if (array.length > 0) {
                                        return array.map((item, index) => {
                                            const processStyle = item.type === 'pass' ? 'pass' : item.type === 'maxpay' ? 'gold' : ''
                                            if (item.type === 'maxpay') {
                                                return (
                                                    <tr key={`h-o-${index}`} className={`item ${processStyle}`}>
                                                        <td colSpan={3}>Вам выплатили максимальную сумму - {utils.convertor(item.total, currency)}</td>
                                                    </tr>
                                                )
                                            }

                                            return (
                                                <tr key={`h-o-${index}`} className={`item ${processStyle}`}>
                                                    {index === 0 ? <td rowSpan={array.length}>Бокс - {ind + 1}</td> : null}
                                                    <td>{item.reason}</td>
                                                    <td>{utils.convertor(item.total, currency)}</td>
                                                    <td>{utils.convertor(item.win ? item.win : 0, currency)}</td>
                                                </tr>
                                            )
                                        })
                                    }

                                })
                            }


                            {
                                refundList.map((item, index) => {
                                    return (
                                        <tr key={`h-o-refund-${index}`} className="item refund">
                                            <td></td>
                                            <td>Возврат</td>
                                            <td colSpan={2}>{utils.convertor(item.total, currency)}</td>
                                        </tr>
                                    )
                                })
                            }



                            <tr key={`h-o-total`}>
                                <td></td>
                                <td>Итого</td>
                                <td>{utils.convertor(total, currency)}</td>
                                <td>{utils.convertor(totalWin, currency)}</td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            )
        }

        return null
    }

    render = () => {

        /* Props and state */
        const { visible, close, histories, loadMore, historyHasMore, always } = this.props
        const { active } = this.state

        /* Fields */
        const animated = visible ? 'animated' : ''
        const bottomStyle = histories.length > 10 ? 'initial' : ''


        return (
            <div className={`modal history ${always} ${animated}`}>
                <div className='modal-content'>

                    {/* Modal Header */}
                    <div className='modal-header'>
                        История игры
                        <div onClick={() => close()} className="modal-close">
                            <Picture src={`${env.mediapoint}/images/x.png`} alt="CLOSE" />
                        </div>
                    </div>

                    {/* Modal Body */}
                    <div className='modal-body'>

                        {/* The current game */}
                        {this._currentGame()}

                        {/* Old games */}
                        {histories.map((item, index) => {

                            let endBalance = parseFloat(item.startBalance)

                            if (item.transactions && Array.isArray(item.transactions) && item.transactions.length > 0) {
                                item.transactions.forEach(transaction => {
                                    if (transaction.type === 'credit') {
                                        endBalance = endBalance + parseFloat(transaction.total)
                                    }
                                    if (transaction.type === 'debit') {
                                        endBalance = endBalance - parseFloat(transaction.total)
                                    }
                                })
                            }

                            return (
                                <div className="history-item" key={`${index}`}>

                                    {/* Draw history head */}
                                    <div onClick={() => this.setState({ active: active === index ? -1 : index })} className={`history-head ${index === active ? 'history-active-head' : ''}`}>

                                        <div className="history-number">
                                            Игра #{item.number}
                                            {/* {index === 0 && <div className="history-number-text"> (LAST GAME)</div>} */}
                                        </div>

                                        <div className="history-head-right">
                                            {this._total(item)}
                                            {this._time(item)}
                                            <CaretDownOutlined />
                                        </div>

                                    </div>

                                    <div className={`history-hidden-box ${index === active ? 'history-hidden-box-active' : ''}`}>

                                        {item.dealer ? <div className="history-dealer">Дилер: {item.dealer}</div> : null}

                                        {item.endReason ? <div className="history-reason-error">{item.endReason}</div> : null}

                                        {(item.transactions && Array.isArray(item.transactions) && item.transactions.length > 0) &&
                                            <div className="history-transactions">

                                                {(item.startBalance !== null || item.startBalance !== undefined) && <div className="history-transaction-balance">Баланс до игры: {utils.convertor(item.startBalance, item.transactions[0].currency)}</div>}
                                                {endBalance > 0 && <div className="history-transaction-balance">Баланс после игры: {utils.convertor(endBalance, item.transactions[0].currency)}</div>}

                                                {this.operationsList(item, index)}

                                            </div>
                                        }

                                        {this._cards(item)}

                                    </div>
                                </div>
                            )
                        })}

                        {historyHasMore &&
                            <div className={`modal-bottom ${bottomStyle}`}>
                                <div className="modal-load-more" onClick={() => loadMore()}>Загрузить еще</div>
                            </div>
                        }

                        <div className="modal-bottom-space" />

                    </div>
                </div>
            </div>

        )

    }

}

export default UVPHistory